import React, { useState, useRef, useEffect } from "react";
import {
  Form,
  Input,
  Select,
  Row,
  Col,
  Tabs,
  Button,
  DatePicker,
  Modal,
  message,
  Image,
  Collapse,
  Radio,
  Card,
} from "antd";
import { CloseOutlined, CopyOutlined } from "@ant-design/icons";
import { UseFetchCaseSetting } from "../../../../modules/admin/AddCaseSetting/hooks/useFetch";
import {
  UseFetchRejectCase,
  UseFetchInformCase,
  UseFetchPendingCase,
  UseFetchSlipProviders,
  UseFetchDecodeQr,
  UseFetchSendSlipDeposit,
  UseFetchUpdateInputUser,
} from "../hooks/useFetch";
import {
  CUSTOMFIELD_TYPE_OPTIONS,
  CUSTOMFIELD_TYPE,
  INPUT_CASE_TO_CASE1,
  REGISTER_TASK,
} from "../../../../data/constant";
import BirthdayPromoCheck from "./BirthdayPromoCheck";
import { showImageModal } from "../../../../function/imageFunc";
import { useFetchListCase1, useFetchListCase2 } from "../../AuditCase/hooks/useFetch";
import {
  useBlacklistTopics,
  useBlacklistByUser,
  useCreateBlacklist,
} from "../../../../hooks/useBlacklist";
import {
  useTelegramChatTargets,
  useSendTelegramChat,
} from "../../../../hooks/useTelegram";
import { bank as bankList } from "../../../../data/bank";
import { useQueryClient } from "@tanstack/react-query";
import dayjs from "dayjs";

function CaseForm({ form, editingRecord, setIsModalOpen, refetch, caseSetting, onTabChange, savedUserId, setSavedUserId }) {
  const [activeTab, setActiveTab] = useState("1");
  const [radioValue, setRadioValue] = useState(null);
  // const companyId = sessionStorage.getItem("activeCompanyId");
  // const { data: caseSetting } = UseFetchCaseSetting(companyId);
  const { mutateAsync: rejectCase, isLoading: isRejecting } = UseFetchRejectCase();
  const { mutateAsync: informCase, isLoading: isInforming } = UseFetchInformCase();
  const { mutateAsync: pendingCase, isLoading: isPending } = UseFetchPendingCase();
  const { mutateAsync: listCase1, isLoading: case1Loading } =
    useFetchListCase1();
  const { mutateAsync: listCase2, isLoading: case2Loading } =
    useFetchListCase2();
  const [case2Options, setCase2Options] = useState(() => []);
  const [case3Options, setCase3Options] = useState(() => []);
  const [customFieldOptions, setCustomFieldOptions] = useState([]);
  const [imageSrc, setImageSrc] = useState({});
  const textareaRefs = useRef({});
  const isSubmittingBlacklistRef = useRef(false); // กันกดบันทึก Blacklist ซ้ำ (double-insert)
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [isInformModalOpen, setIsInformModalOpen] = useState(false);
  const [isPendingModalOpen, setIsPendingModalOpen] = useState(false);
  const [rejectForm] = Form.useForm();
  const [informForm] = Form.useForm();
  const [pendingForm] = Form.useForm();
  const [rejectImages, setRejectImages] = useState([]);
  const [informImages, setInformImages] = useState([]);
  const [selectedCase1, setSelectedCase1] = useState(null);
  const [selectedCase2, setSelectedCase2] = useState(null);
  const [selectedCase3, setSelectedCase3] = useState(null);

  const [remarkText, setRemarkText] = useState('');

  // ===== Slip deposit (ส่งสลิปไป provider) =====
  const slipCompanyId = sessionStorage.getItem("activeCompanyId");
  const { data: slipProviders = [] } = UseFetchSlipProviders(slipCompanyId);
  const { mutateAsync: decodeQr, isLoading: isDecodingQr } = UseFetchDecodeQr();
  const { mutateAsync: sendSlip, isLoading: isSendingSlip } = UseFetchSendSlipDeposit();
  const [isSlipModalOpen, setIsSlipModalOpen] = useState(false);
  const [selectedSlipImage, setSelectedSlipImage] = useState(null);
  const [slipQrString, setSlipQrString] = useState("");
  const [slipTransactionId, setSlipTransactionId] = useState("");
  const [selectedProviderId, setSelectedProviderId] = useState(null);

  // ===== ส่งแชท Telegram (รูปสลิป + ข้อความเข้ากลุ่ม) =====
  const { data: chatTargets = [] } = useTelegramChatTargets();
  const { mutateAsync: sendTgChat, isLoading: isSendingChat } = useSendTelegramChat();
  const [isChatModalOpen, setIsChatModalOpen] = useState(false);
  const [selectedChatTargetId, setSelectedChatTargetId] = useState(null);
  const [chatImageUrl, setChatImageUrl] = useState(null);
  const [chatCaption, setChatCaption] = useState("");

  // ===== Blacklist =====
  const blacklistQueryClient = useQueryClient();
  // editingRecord เป็น snapshot ที่ parent ถือไว้ — refetch() ไม่อัปเดตตัวมันเอง
  // userId ที่เพิ่งกรอกเลยต้องเก็บเป็น state แยก (savedUserId) และเก็บไว้ที่ "page"
  // เพราะ handleModalOk (ด่านกันปิดเคส) อยู่ที่ page ต้องเห็นค่าล่าสุดด้วย
  // ⚠️ ห้ามแก้เป็นการ setEditingRecord ทับ — effect ด้านล่างผูกกับ [editingRecord]
  //    จะรีเซ็ต case2/case3/customFields/รูป ทิ้งงานที่กรอกไว้ทั้งหมด
  const blacklistUserId = savedUserId ?? editingRecord?.userId;
  const { data: blacklistTopics = [] } = useBlacklistTopics();
  const { data: userBlacklist = [] } = useBlacklistByUser(blacklistUserId);
  const { mutateAsync: createBlacklist, isLoading: isSavingBlacklist } = useCreateBlacklist();
  const [isBlacklistModalOpen, setIsBlacklistModalOpen] = useState(false);
  // 'case' = ปุ่มเดิม ใช้ UserId ของเคสนี้ + ลงประวัติเคส
  // 'manual' = กรอกเองทั้งหมด (คนละคนกับลูกค้าของเคสได้) → ไม่ผูกกับเคส ไม่ลงประวัติเคส
  const [blacklistMode, setBlacklistMode] = useState("case");
  const [isBlacklistViewOpen, setIsBlacklistViewOpen] = useState(false);
  const [blacklistForm] = Form.useForm();
  // ปุ่มกรอกเอง: พิมพ์ UserId เสร็จแล้วเช็คให้เลยว่าคนนี้ติด blacklist อยู่แล้วหรือยัง
  // หน่วง 400ms ไม่ให้ยิง API ทุกตัวอักษรที่พิมพ์
  const manualUserIdInput = Form.useWatch("manualUserId", blacklistForm);
  const [manualCheckId, setManualCheckId] = useState("");
  useEffect(() => {
    const id = String(manualUserIdInput || "").trim();
    const timer = setTimeout(() => setManualCheckId(id), 400);
    return () => clearTimeout(timer);
  }, [manualUserIdInput]);
  const isManualChecking = isBlacklistModalOpen && blacklistMode === "manual";
  const {
    data: manualBlacklist = [],
    isFetching: isFetchingManual,
    isError: isManualCheckError,
  } = useBlacklistByUser(isManualChecking ? manualCheckId : null);
  // ยังพิมพ์อยู่ (ค่าที่เช็คไม่ใช่ค่าล่าสุด) ก็นับเป็นกำลังเช็ค — ไม่โชว์ผลของเลขก่อนหน้า
  const isCheckingManual =
    isFetchingManual || String(manualUserIdInput || "").trim() !== manualCheckId;
  // modal ดูรายละเอียดใช้ร่วมกัน: ของลูกค้าในเคส หรือของ UserId ที่กรอกเอง
  const [blacklistViewTarget, setBlacklistViewTarget] = useState("case");
  const viewBlacklistUserId = blacklistViewTarget === "manual" ? manualCheckId : blacklistUserId;
  const viewBlacklist = blacklistViewTarget === "manual" ? manualBlacklist : userBlacklist;

  // ===== กรอก UserId ให้เคสที่ส่งมาแบบ "ไม่มี User" =====
  const [userIdInput, setUserIdInput] = useState("");
  const { mutateAsync: updateInputUser, isLoading: isSavingUserId } = UseFetchUpdateInputUser();

  const handleSaveUserId = async () => {
    const value = userIdInput.trim();
    if (!value || isSavingUserId) return;
    try {
      const res = await updateInputUser({ id: editingRecord.id, userId: value });
      message.success("บันทึก User สำเร็จ");
      setUserIdInput("");
      // ใช้ค่าที่ backend ล้างแล้วส่งกลับมา (ตัดอักขระที่ไม่ใช่ตัวเลขออก) จะได้ตรงกับที่เก็บจริง
      setSavedUserId(res?.result?.userId || value);
      // ดึงเคสใหม่ (userId เปลี่ยน) + เช็ค blacklist ของ user ที่เพิ่งกรอกทันที
      refetch();
      blacklistQueryClient.invalidateQueries(["blacklistByUser"]);
    } catch (error) {
      message.error(error?.response?.data?.message || "บันทึก User ไม่สำเร็จ");
    }
  };

  // caseSetting มาจาก react-query → ตอนแรกเป็น undefined แล้วค่อยมาทีหลัง
  // ใช้เป็น dep ของ effect ที่เซ็ต default case1/case2/case3 เพื่อให้ "รอ" caseSetting ได้
  // (เดิม effect เช็ค caseSetting แต่ไม่ใส่ใน deps → ถ้าเปิด modal ก่อน caseSetting โหลดเสร็จ
  //  จะ bail แล้วไม่ re-run อีกเลย → dropdown case1 ว่างค้าง)
  // ใช้ boolean ไม่ใช่ตัว array เพื่อไม่ให้ re-run ทับค่าที่ user เลือกไว้ ตอน react-query refetch
  const isCaseSettingReady = Array.isArray(caseSetting) && caseSetting.length > 0;

  // เคลียร์ state เมื่อ editingRecord เปลี่ยน หรือเมื่อเริ่มต้นใหม่
  useEffect(() => {
    setCustomFieldOptions([]);
    setCase2Options([]);
    setCase3Options([]);
    setImageSrc({});
    setActiveTab("1");
    setSelectedCase2(null);
    setSelectedCase3(null);
    // เปิดเคสใหม่ → ลืมค่าที่พิมพ์ค้างไว้ (savedUserId ถูกล้างที่ page ตอนเปิด/ปิด modal)
    setUserIdInput("");

    // Set initial form values และ sync radioValue
    setRadioValue("1");
    form.setFieldValue('radioChoice', '1');
    form.setFieldValue('remarkText', '');
    pendingForm.resetFields()
  }, [editingRecord, form]);

  // useEffect สำหรับ set case1 และเรียก handleCase1Change
  useEffect(() => {
    if (editingRecord && caseSetting && caseSetting.length > 0) {
      let case1Value = null;
      case1Value = INPUT_CASE_TO_CASE1[editingRecord.caseName] || null;

      if (case1Value) {
        setSelectedCase1(case1Value);
        form.setFieldValue("case1", case1Value);
        //handleCase1Change(case1Value);
      }
    }
  }, [editingRecord, form, isCaseSettingReady]);

  useEffect(() => {
    const loadCaseDetails = async () => {
      if (!editingRecord || !caseSetting || caseSetting.length === 0) {
        return;
      }

      const case1Value = INPUT_CASE_TO_CASE1[editingRecord.caseName];
      if (!case1Value) {
        return;
      }

      // Set case1 value and trigger its change handler
      setSelectedCase1(case1Value);
      form.setFieldValue("case1", case1Value);
      // handleCase1Change(case1Value); // This will be called by the other useEffect or should be integrated here if it's not just for fetching options

      const [remarkCase1, remarkCase2] = (editingRecord.note || "")
        .split("-")
        .map((s) => s.trim());

      // Load case2 options
      if (case1Value) {
        const r2 = await listCase1({ case1: case1Value });
        const fetchedCase2List = r2?.result || [];
        setCase2Options(fetchedCase2List);
        if (case1Value.amount) {
          form.setFieldValue("amount", case1Value.amount);
        }
        if (remarkCase1) {
          const foundCase2 = fetchedCase2List.find((item) => item.remark === remarkCase1);
          if (foundCase2) {
            setSelectedCase2(foundCase2);
            form.setFieldValue("case2", foundCase2.id);
            form.setFieldValue("remarkText", generateRemarkText());

            // handleCase2Change(foundCase2.id); // This will be called by the other useEffect or should be integrated here

            // Load case3 options based on foundCase2.id
            const r3 = await listCase2({ case2: foundCase2.id });
            const fetchedCase3List = r3?.result || [];
            await setCase3Options(fetchedCase3List);

            if (remarkCase2) {
              const foundCase3 = fetchedCase3List.find((item) => item.remark === remarkCase2);
              if (foundCase3) {
                form.setFieldValue("case3", foundCase3.id);
                form.setFieldValue("remarkText", generateRemarkText());
                setSelectedCase3(foundCase3);
                handleCase3Change(foundCase3.id, fetchedCase3List);
                // handleCase3Change(foundCase3.id); // This will be called by the other useEffect or should be integrated here
              }
            }
          }
        }
      }
    };

    loadCaseDetails();
  }, [editingRecord, form, isCaseSettingReady]);


  // Sync imageSrc กับ form values - ส่ง array ของรูปภาพจริงๆ ไม่ใช่ "has-images"
  useEffect(() => {
    customFieldOptions.forEach((field) => {
      if (field.typeDisplay === "Image") {
        // ใช้ number เป็น key เพื่อให้เรียงตาม number ได้
        const formFieldName = field.number.toString();
        const images = imageSrc[field.number] || [];
        // ส่ง array ของรูปภาพจริงๆ ไม่ใช่ "has-images"
        form.setFieldValue(
          ["customFields", formFieldName],
          images.length > 0 ? images : ""
        );
      }
    });
  }, [imageSrc, customFieldOptions, form]);

  // Sync remarkText กับ form values เมื่อ case2 หรือ case3 เปลี่ยน
  useEffect(() => {
    if (radioValue === "1") {
      setRemarkText(generateRemarkText());
      form.setFieldValue('remarkText', generateRemarkText());
    }
  }, [selectedCase2, selectedCase3, radioValue, form]);

  // Sync radioValue กับ form value เมื่อ component mount
  useEffect(() => {
    const formRadioValue = form.getFieldValue('radioChoice');
    if (formRadioValue && formRadioValue !== radioValue) {
      setRadioValue(formRadioValue);
    }
  }, [form, radioValue]);

  // ส่งข้อมูลการเปลี่ยนแปลงแท็บไปยัง parent component
  useEffect(() => {
    if (onTabChange && customFieldOptions.length > 0) {
      const currentIndex = customFieldOptions.findIndex(
        (field) => (field.number + 1).toString() === activeTab
      );
      const isLastTab = currentIndex === customFieldOptions.length - 1;
      onTabChange(isLastTab);
    } else if (onTabChange) {
      // ถ้าไม่มี customFieldOptions หรือ activeTab เป็น "1" ให้ส่ง false
      onTabChange(false);
    }
  }, [activeTab, customFieldOptions, onTabChange]);

  const handleNextTab = () => {
    // หา tab ปัจจุบันใน customFieldOptions
    const currentIndex = customFieldOptions.findIndex(
      (field) => (field.number + 1).toString() === activeTab
    );

    if (currentIndex >= 0 && currentIndex < customFieldOptions.length - 1) {
      const nextField = customFieldOptions[currentIndex + 1];
      setActiveTab((nextField.number + 1).toString());
    }
  };

  const handlePrevTab = () => {
    // หา tab ปัจจุบันใน customFieldOptions
    const currentIndex = customFieldOptions.findIndex(
      (field) => (field.number + 1).toString() === activeTab
    );

    if (currentIndex > 0) {
      const prevField = customFieldOptions[currentIndex - 1];
      setActiveTab((prevField.number + 1).toString());
    }
  };

  const handleCase1Change = async (value) => {
    const r = await listCase1({ case1: value });
    const case1 = r?.result || [];
    setSelectedCase1(case1.length > 0 ? case1[0].type : null);
    setCase2Options(case1);
    setCustomFieldOptions([]);
    setSelectedCase2(null);
    setSelectedCase3(null);
    form.setFieldsValue({
      case2: "",
      case3: "",
    });
  };

  const handleCase2Change = async (value) => {
    const case2 = await listCase2({ case2: value });
    const selectCase2 = case2Options?.find((item) => item.id == value) || [];
    setCase3Options(case2?.result || []);
    setCustomFieldOptions([]);
    setSelectedCase2(selectCase2);
    setSelectedCase3(null);
    // ไม่ reset case3 ถ้ามี editingRecord (กำลังโหลดข้อมูลเดิม)
    if (!editingRecord) {
      form.setFieldsValue({
        case3: "",
      });
    }
  };

  const handleCase3Change = (value, optionsSource) => {
    const source = Array.isArray(optionsSource) ? optionsSource : case3Options;
    const case3 =
      source.length > 0
        ? source.find((item) => item.id == value)
        : [];
    setSelectedCase3(case3);
    const customFieldOptions = case3.customfield_subcase
      .sort((a, b) => a.number - b.number)
      .map((item, index) => {
        const customField = CUSTOMFIELD_TYPE_OPTIONS.find(
          (option) => option.value == item.type
        );
        return {
          title: item.customfield_name,
          // type ที่ bundle นี้ไม่รู้จัก (FE เก่า/ยังไม่ deploy) → ปล่อยว่าง ดีกว่าจอขาว
          typeDisplay: customField?.label || "",
          number: item.number, // ใช้ number จาก API แทน index + 1
          id: index,
          type: item.type,
          example_image: item.example_image,
          description: item.description,
          image_multiple: item.image_multiple, // 0=รูปเดียว, 1=หลายรูป (เฉพาะ type Image)
        };
      });
    setCustomFieldOptions(customFieldOptions);

    // แปลง customFields จาก array/object format เป็น number key เมื่อเลือก case3 และมี editingRecord
    if (editingRecord?.dataManage?.customFields && customFieldOptions.length > 0) {
      const convertedCustomFields = {};
      const customFields = editingRecord.dataManage.customFields;

      // รองรับทั้ง array format (ใหม่) และ object format (เก่า)
      if (Array.isArray(customFields)) {
        // Format ใหม่: array ของ objects [{number, title, value}, ...]
        customFields.forEach(field => {
          const matchingOption = customFieldOptions.find(opt => opt.number === field.number || opt.title === field.title);
          if (matchingOption && field.value !== undefined && field.value !== null && field.value !== '') {
            convertedCustomFields[matchingOption.number.toString()] = field.value;
            // ตั้งค่า imageSrc เพื่อไม่ให้ state ทับ value ในตอน mount
            if (matchingOption.typeDisplay === "Image" && field.value !== "") {
              const valArray = Array.isArray(field.value) ? field.value : [field.value];
              setImageSrc(prev => ({ ...prev, [matchingOption.number]: valArray }));
            }
          }
        });
      } else if (typeof customFields === 'object') {
        // Format เก่า: object {title: value, ...}
        customFieldOptions.forEach(field => {
          const value = customFields[field.title];
          if (value !== undefined && value !== null) {
            convertedCustomFields[field.number.toString()] = value;
            if (field.typeDisplay === "Image" && value !== "") {
              const valArray = Array.isArray(value) ? value : [value];
              setImageSrc(prev => ({ ...prev, [field.number]: valArray }));
            }
          }
        });
      }

      if (Object.keys(convertedCustomFields).length > 0) {
        form.setFieldsValue({
          customFields: convertedCustomFields
        });
      }
    }
  };

  // แปลง customFields จาก array/object format เป็น number key เมื่อ customFieldOptions เปลี่ยนและมี editingRecord
  useEffect(() => {
    if (customFieldOptions.length > 0 && editingRecord?.dataManage?.customFields) {
      const currentCustomFields = form.getFieldValue('customFields') || {};
      const customFields = editingRecord.dataManage.customFields;

      // ตรวจสอบว่า customFields ใช้ title key หรือ number key อยู่แล้ว
      const isUsingTitleKey = customFieldOptions.some(field =>
        currentCustomFields[field.title] !== undefined
      );

      if (isUsingTitleKey) {
        // แปลงจาก title key เป็น number key
        const convertedCustomFields = {};
        customFieldOptions.forEach(field => {
          const value = currentCustomFields[field.title] ||
            (Array.isArray(customFields)
              ? customFields.find(cf => cf.title === field.title || cf.number === field.number)?.value
              : customFields[field.title]);
          if (value !== undefined && value !== null) {
            convertedCustomFields[field.number.toString()] = value;
            if (field.typeDisplay === "Image" && value !== "") {
              const valArray = Array.isArray(value) ? value : [value];
              setImageSrc(prev => ({ ...prev, [field.number]: valArray }));
            }
          }
        });

        if (Object.keys(convertedCustomFields).length > 0) {
          form.setFieldsValue({
            customFields: convertedCustomFields
          });
        }
      }
    }
  }, [customFieldOptions, editingRecord, form]);

  const handlePaste = (event, fieldNumber) => {
    // field รูปแบบ single (image_multiple != 1) → เก็บได้รูปเดียว, วางรูปใหม่ทับของเดิม
    const fieldOption = customFieldOptions.find((f) => f.number === fieldNumber);
    const isMultiple = Number(fieldOption?.image_multiple) === 1;
    const items = event.clipboardData.items;
    for (const item of items) {
      if (item.type.indexOf("image") === 0) {
        const file = item.getAsFile();
        const reader = new FileReader();
        reader.onload = (e) => {
          setImageSrc((prev) => {
            const newImageArray = isMultiple
              ? [...(prev[fieldNumber] || []), e.target.result]
              : [e.target.result];
            return {
              ...prev,
              [fieldNumber]: newImageArray,
            };
          });
          // Update form value will be handled cleanly by the useEffect that watches imageSrc
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const handleDeleteImage = (fieldNumber, imageIndex) => {
    const newImageArray = imageSrc[fieldNumber].filter(
      (_, index) => index !== imageIndex
    );

    setImageSrc((prev) => ({
      ...prev,
      [fieldNumber]: newImageArray,
    }));

    // Update form value
    const field = customFieldOptions.find((f) => f.number === fieldNumber);
    if (field) {
      // ใช้ number เป็น key เพื่อให้เรียงตาม number ได้
      const formFieldName = field.number.toString();
      form.setFieldValue(
        ["customFields", formFieldName],
        newImageArray.length > 0 ? newImageArray : ""
      );
    }
  };

  const handleRejectCase = () => {
    if (!editingRecord?.id) {
      message.error("ไม่สามารถ reject case ได้ กรุณาตรวจสอบข้อมูล");
      return;
    }
    // ไม่บล็อกด้วย editingRecord.status ที่นี่ — มันเป็น snapshot จาก cache ที่อาจล้าสมัย
    // ตอนเคสถูกหลายคนทำพร้อมกัน สถานะจะแกว่ง → บล็อกมั่ว ("กดไม่ได้รอบแรก")
    // ปล่อยให้ backend เป็นคนตัดสินสถานะจริง (มี guard 'already rejected' อยู่แล้ว)
    setIsRejectModalOpen(true);
  };

  const handleRejectSubmit = async () => {
    try {
      const values = await rejectForm.validateFields();
      const currentUserId = sessionStorage.getItem("id");
      await rejectCase({
        caseId: editingRecord.id,
        rejectRemark: values.rejectRemark,
        rejectBy: currentUserId, // ใช้ current user ID
        rejectImages: rejectImages.map((image) =>
          image.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
        ), // แปลงเป็น base64 อย่างเดียว
      });
      message.success("Reject case สำเร็จ");
      setIsRejectModalOpen(false);
      rejectForm.resetFields();
      setRejectImages([]);
      // ปิด modal หลักด้วย
      if (setIsModalOpen) {
        setIsModalOpen(false);
      }
      refetch(); // mutateAsync รอจน reject เสร็จแล้ว → refetch ทันที (ไม่ต้องหน่วง)
    } catch (error) {
      // reject พลาดมักเพราะเคสถูกคนอื่น/แอดมินดำเนินการไปแล้ว (สถานะเปลี่ยน)
      // → refetch ให้เห็นสถานะล่าสุดทันที ผู้ใช้กดใหม่ได้เลย ไม่ต้อง "รับใหม่" เอง
      message.error(
        error?.response?.data?.message ||
          "reject ไม่สำเร็จ — เคสอาจเพิ่งถูกดำเนินการโดยคนอื่น กำลังรีเฟรชสถานะล่าสุด"
      );
      refetch?.();
    }
  };

  const handleRejectCancel = () => {
    setIsRejectModalOpen(false);
    rejectForm.resetFields();
    setRejectImages([]);
  };

  const handleRejectImagePaste = (e) => {
    e.preventDefault();
    const items = e.clipboardData.items;

    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image") !== -1) {
        const file = items[i].getAsFile();
        const reader = new FileReader();

        reader.onload = (event) => {
          setRejectImages((prev) => [...prev, event.target.result]);
        };

        reader.readAsDataURL(file);
        break;
      }
    }
  };

  const handleDeleteRejectImage = (index) => {
    setRejectImages((prev) => prev.filter((_, i) => i !== index));
  };

  // ===== Inform: ส่งกลับขอข้อมูลเพิ่ม (ไม่ใช่การตัดสินว่าผิด) =====
  const handleInformCase = () => {
    if (!editingRecord?.id) {
      message.error("ไม่สามารถ inform case ได้ กรุณาตรวจสอบข้อมูล");
      return;
    }
    // ไม่บล็อกด้วย editingRecord.status (เป็น snapshot จาก cache ที่อาจล้าสมัย)
    // ปล่อยให้ backend ตัดสิน — มี guard 'already informed' อยู่แล้ว เหมือนฝั่ง reject
    setIsInformModalOpen(true);
  };

  const handleInformSubmit = async () => {
    try {
      const values = await informForm.validateFields();
      const currentUserId = sessionStorage.getItem("id");
      await informCase({
        caseId: editingRecord.id,
        informRemark: values.informRemark,
        informBy: currentUserId,
        informImages: informImages.map((image) =>
          image.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
        ),
      });
      message.success("ส่งเคสกลับเพื่อขอข้อมูลเพิ่มสำเร็จ");
      setIsInformModalOpen(false);
      informForm.resetFields();
      setInformImages([]);
      if (setIsModalOpen) {
        setIsModalOpen(false);
      }
      refetch();
    } catch (error) {
      if (error?.errorFields) return; // validation ของ antd
      message.error(
        error?.response?.data?.message ||
          "inform ไม่สำเร็จ — เคสอาจเพิ่งถูกดำเนินการโดยคนอื่น กำลังรีเฟรชสถานะล่าสุด"
      );
      refetch?.();
    }
  };

  const handleInformCancel = () => {
    setIsInformModalOpen(false);
    informForm.resetFields();
    setInformImages([]);
  };

  const handleInformImagePaste = (e) => {
    e.preventDefault();
    const items = e.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image") !== -1) {
        const file = items[i].getAsFile();
        const reader = new FileReader();
        reader.onload = (event) => {
          setInformImages((prev) => [...prev, event.target.result]);
        };
        reader.readAsDataURL(file);
        break;
      }
    }
  };

  const handleDeleteInformImage = (index) => {
    setInformImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handlePendingCase = () => {
    if (!editingRecord?.id) {
      message.error(
        "ไม่สามารถเปลี่ยนสถานะ case เป็น pending ได้ กรุณาตรวจสอบข้อมูล"
      );
      return;
    }
    if (editingRecord.status === "Pending") {
      message.warning("Case นี้เป็น Pending อยู่แล้ว");
      return;
    }
    setIsPendingModalOpen(true);
  };

  const handlePendingSubmit = async () => {
    try {
      const values = await pendingForm.validateFields();
      const currentUserId = sessionStorage.getItem("id");
      await pendingCase({
        caseId: editingRecord.id,
        pendingRemark: values.pendingRemark,
        pending_By: currentUserId,
      });
      message.success("เปลี่ยนสถานะ case เป็น Pending สำเร็จ");
      if (setIsModalOpen) {
        setIsModalOpen(false);
      }
      setIsPendingModalOpen(false);
      refetch(); // mutateAsync รอจน pending เสร็จแล้ว → refetch ทันที (ไม่ต้องหน่วง)
    } catch (error) {
      message.error("ไม่สามารถเปลี่ยนสถานะ case เป็น pending ได้");
    }
  };

  const handlePendingCancel = () => {
    setIsPendingModalOpen(false);
    pendingForm.resetFields()
  };

  // ===== Slip deposit handlers =====
  const handleOpenSlipModal = () => {
    if (!editingRecord?.id) {
      message.error("ไม่พบข้อมูลเคส");
      return;
    }
    setSelectedSlipImage(null);
    setSlipQrString("");
    // prefill Transaction ID จากช่องที่ operator กรอกในฟอร์ม หรือ ts_id เดิมของเคส
    setSlipTransactionId(
      form.getFieldValue("transactionId") || editingRecord?.ts_id || ""
    );
    // ถ้ามี provider เจ้าเดียว เลือกให้เลย
    setSelectedProviderId(slipProviders.length === 1 ? slipProviders[0].id : null);
    setIsSlipModalOpen(true);
  };

  const handleSelectSlipImage = async (imageUrl) => {
    setSelectedSlipImage(imageUrl);
    setSlipQrString("");
    try {
      const res = await decodeQr({ imageUrl });
      const qr = res?.result?.qrString || "";
      setSlipQrString(qr);
      await message.destroy();
      message.success("ถอด QR สำเร็จ");
    } catch (error) {
      await message.destroy();
      message.error(
        error?.response?.data?.message ||
          error?.message ||
          "ถอด QR ไม่สำเร็จ กรุณาเลือกรูปอื่นหรือกรอก QR เอง"
      );
    }
  };

  const handleSendSlip = async () => {
    if (!selectedProviderId) {
      message.warning("กรุณาเลือกผู้ให้บริการ");
      return;
    }
    if (!slipQrString) {
      message.warning("ยังไม่มี QR กรุณาเลือกรูปสลิปหรือกรอก QR");
      return;
    }
    if (!slipTransactionId) {
      message.warning("กรุณากรอก Transaction ID");
      return;
    }
    try {
      const res = await sendSlip({
        inputId: editingRecord.id,
        providerId: selectedProviderId,
        qrString: slipQrString,
        transactionId: slipTransactionId,
      });
      await message.destroy();
      message.success(res?.message || "ส่งสลิปสำเร็จ");
      setIsSlipModalOpen(false);
    } catch (error) {
      await message.destroy();
      message.error(
        error?.response?.data?.message ||
          error?.message ||
          "ส่งสลิปไม่สำเร็จ"
      );
    }
  };

  const handleSlipModalCancel = () => {
    setIsSlipModalOpen(false);
    setSelectedSlipImage(null);
    setSlipQrString("");
  };

  // ===== ส่งแชท Telegram handlers =====
  const handleOpenChatModal = () => {
    if (!editingRecord?.id) {
      message.error("ไม่พบข้อมูลเคส");
      return;
    }
    setChatImageUrl(null);
    // prefill ข้อความ = เลขธุรกรรม (แก้/พิมพ์เพิ่มเองได้)
    setChatCaption(form.getFieldValue("transactionId") || editingRecord?.ts_id || "");
    // มีเจ้าเดียวเลือกให้เลย
    setSelectedChatTargetId(chatTargets.length === 1 ? chatTargets[0].id : null);
    setIsChatModalOpen(true);
  };

  const handleSendChat = async () => {
    if (!selectedChatTargetId) {
      message.warning("กรุณาเลือกเจ้า/กลุ่มปลายทาง");
      return;
    }
    if (!chatImageUrl) {
      message.warning("กรุณาเลือกรูปสลิป");
      return;
    }
    try {
      const res = await sendTgChat({
        targetId: selectedChatTargetId,
        inputId: editingRecord?.id,
        imageUrl: chatImageUrl,
        caption: chatCaption,
      });
      await message.destroy();
      message.success(res?.message || "ส่งเข้ากลุ่มสำเร็จ");
      setIsChatModalOpen(false);
    } catch (error) {
      await message.destroy();
      message.error(
        error?.response?.data?.message || error?.message || "ส่งเข้ากลุ่มไม่สำเร็จ"
      );
    }
  };

  // ===== Blacklist handlers =====
  const handleOpenBlacklistModal = () => {
    if (!editingRecord?.id) {
      message.error("ไม่พบข้อมูลเคส");
      return;
    }
    // blacklist ผูกกับ userId — เคสที่ยังไม่มี User จะบันทึกเป็น userId ว่าง = ค้นเจอไม่ได้
    if (!blacklistUserId) {
      message.warning("เคสนี้ยังไม่มี User — กรุณากรอก UserId ก่อนเพิ่ม Blacklist");
      return;
    }
    blacklistForm.resetFields();
    setBlacklistMode("case");
    setIsBlacklistModalOpen(true);
  };

  const handleOpenManualBlacklistModal = () => {
    blacklistForm.resetFields();
    setManualCheckId("");
    setBlacklistMode("manual");
    setIsBlacklistModalOpen(true);
  };

  const handleSubmitBlacklist = async () => {
    // กันกดซ้ำ: มีช่อง async (validateFields) ก่อน mutation จะ set loading
    // กดรัว ๆ ตอนนั้นทำให้ createBlacklist ยิง 2 ครั้ง → บันทึกซ้ำ 2 แถวเวลาเดียวกัน
    if (isSubmittingBlacklistRef.current) return;
    isSubmittingBlacklistRef.current = true;
    try {
      const values = await blacklistForm.validateFields();
      const isManual = blacklistMode === "manual";
      const targetUserId = isManual ? String(values.manualUserId || "").trim() : blacklistUserId;
      await createBlacklist({
        userId: targetUserId, // ปุ่มเดิม = userId ของเคส · กรอกเอง = ที่พิมพ์
        topicId: values.topicId,
        accountName: values.accountName,
        bank: values.bank,
        bankAccount: values.bankAccount,
        note: values.note,
        inputId: isManual ? null : editingRecord.id, // ปุ่มเดิมลง history_logs ของเคสนี้
      });
      await message.destroy();
      message.success("เพิ่ม Blacklist สำเร็จ");
      setIsBlacklistModalOpen(false);
      blacklistForm.resetFields();
      // refresh จำนวน/รายการ blacklist ของ user คนนี้ (กรอกเองเป็นลูกค้าของเคสนี้ก็ต้องอัปเดตตัวเลขด้วย)
      blacklistQueryClient.invalidateQueries(["blacklistByUser", targetUserId]);
      if (targetUserId !== blacklistUserId) {
        blacklistQueryClient.invalidateQueries(["blacklistByUser", blacklistUserId]);
      }
    } catch (error) {
      if (error?.errorFields) return; // validation
      await message.destroy();
      message.error(error?.response?.data?.message || "เพิ่ม Blacklist ไม่สำเร็จ");
    } finally {
      isSubmittingBlacklistRef.current = false;
    }
  };

  const handleRadioChange = (e) => {
    setRadioValue(e.target.value);
    form.setFieldValue('radioChoice', e.target.value);
  };

  const generateRemarkText = () => {
    const case2Remark = selectedCase2?.remark || "";
    const case3Remark = selectedCase3?.remark || "";
    const timeDeposit = form.getFieldValue('timeDeposit') || "";
    const dateDeposit = form.getFieldValue('dateDeposit') || "";

    const caseParts = [case2Remark, case3Remark].filter(Boolean);
    const timeParts = [
      timeDeposit,
      dateDeposit && typeof dateDeposit.format === "function"
        ? dateDeposit.format("DD/MM/YYYY")
        : dateDeposit || "",
    ].filter(Boolean);

    const segments = [];
    if (caseParts.length > 0) segments.push(caseParts.join("-"));
    if (timeParts.length > 0) segments.push(timeParts.join("-"));
    return segments.join("-");
  };

  const handleCopyText = () => {
    const textToCopy = remarkText;

    if (!textToCopy) {
      message.warning("กรุณาเลือก Case ก่อน Copy");
      return;
    }

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        message.success("คัดลอกเรียบร้อยแล้ว");
      })
      .catch(() => {
        message.error("ไม่สามารถคัดลอกได้");
      });
  };

  return (
    <Form form={form} layout="vertical">
      <Row gutter={24}>
        {/* Left side - Regular form display */}
        <Col span={8}>
          <div
            style={{
              background: "#f5f5f5",
              padding: "15px",
              borderRadius: "8px",
              border: "1px solid #d9d9d9",
              marginBottom: "20px",
            }}
          >
            <h3
              style={{
                margin: "0 0 10px 0",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              {editingRecord ? "Current Case Information" : "Case Information"}
            </h3>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                fontSize: "14px",
              }}
            >
              <div style={{ flex: 1 }}>
                <div>
                  Case Name: {editingRecord ? editingRecord.caseName : "N/A"}
                </div>
                {editingRecord && !blacklistUserId ? (
                  // เคสถูกส่งมาแบบ "ไม่มี User" → กรอกตรงนี้ได้เลย (เขียนลงคอลัมน์ Inputs.userId)
                  <div style={{ display: "flex", alignItems: "center", gap: 6, margin: "2px 0" }}>
                    <span style={{ color: "#fa8c16", fontWeight: 500 }}>UserId: ไม่มี</span>
                    <Input
                      size="small"
                      style={{ width: 150 }}
                      placeholder="กรอก UserId"
                      maxLength={100}
                      value={userIdInput}
                      onChange={(e) => setUserIdInput(e.target.value)}
                      onPressEnter={handleSaveUserId}
                      disabled={isSavingUserId}
                    />
                    <Button
                      size="small"
                      type="primary"
                      loading={isSavingUserId}
                      disabled={!userIdInput.trim() || isSavingUserId}
                      onClick={handleSaveUserId}
                    >
                      บันทึก
                    </Button>
                  </div>
                ) : (
                  <div>
                    UserId: {editingRecord ? blacklistUserId : "N/A"}
                  </div>
                )}
                {editingRecord && (
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    Blacklist:{" "}
                    <span
                      style={{
                        fontWeight: "bold",
                        color: userBlacklist.length > 0 ? "#ff4d4f" : "#52c41a",
                      }}
                    >
                      {userBlacklist.length} รายการ
                    </span>
                    {userBlacklist.length > 0 && (
                      <Button
                        size="small"
                        danger
                        onClick={() => {
                          setBlacklistViewTarget("case");
                          setIsBlacklistViewOpen(true);
                        }}
                      >
                        ดู
                      </Button>
                    )}
                  </div>
                )}
                <div>
                  Status:{" "}
                  {editingRecord ? editingRecord.status || "N/A" : "N/A"}
                </div>
                <div style={{ display: "flex", gap: "4px" }}>
                  Note:{" "}
                  {editingRecord ? (
                    <div style={{ color: "#ff0000ff" }}>
                      {(editingRecord.note || "N/A")
                        .split("\n")
                        .map((line, index) => (
                          <div key={index}>{line}</div>
                        ))}
                    </div>
                  ) : (
                    "N/A"
                  )}
                </div>
                <div style={{ gap: "4px",backgroundColor: "white", paddingLeft: "10px", borderRadius: "8px",border: "1px solid #d9d9d9" }}>
                  <div style={{ marginTop: "10px" }}>
                    ชื่อธนาคาร: {editingRecord ? editingRecord.bank_name : "N/A"}
                  </div>
                  <div >
                    เลขบัญชี: {editingRecord ? editingRecord.bankId : "N/A"}
                  </div>
                </div>
              </div>
              {editingRecord &&
                editingRecord.imgChoice &&
                editingRecord.imgChoice.length > 0 && (
                  <div
                    style={{
                      marginLeft: "15px",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "5px",
                      maxWidth: "150px",
                    }}
                  >
                    {editingRecord.imgChoice.map((image, index) => (
                      <img
                        key={index}
                        src={image.img_url}
                        alt={`Receipt ${index + 1}`}
                        style={{
                          width: "50px",
                          height: "50px",
                          objectFit: "cover",
                          borderRadius: "3px",
                          border: "1px solid #d9d9d9",
                          cursor: "pointer",
                        }}
                        onClick={() => showImageModal(image.img_url)}
                      />
                    ))}
                  </div>
                )}
            </div>
          </div>
          <Form.Item
            name="case1"
            label="Case1"
            rules={[{ required: true, message: "Please select case1!" }]}
          >
            <Select onChange={handleCase1Change}>
              <Select.Option value="1">Deposit</Select.Option>
              <Select.Option value="2">Withdraw</Select.Option>
              <Select.Option value="3">Etc</Select.Option>
              <Select.Option value="4">Panel</Select.Option>
              <Select.Option value="5">{REGISTER_TASK}</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="case2"
            label="Case2"
            rules={[{ required: true, message: "Please select case2!" }]}
          >
            <Select onChange={handleCase2Change}>
              {/* หน้าทำงาน: โชว์เฉพาะ case2 ที่เปิดใช้งาน (คงตัวที่เลือกอยู่ไว้ เผื่อเคสเก่าใช้ตัวที่เพิ่งปิด) */}
              {case2Options
                .filter((item) => Number(item.enable) !== 0 || item.id === selectedCase2?.id)
                .map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.casename}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="case3"
            label="Case3"
            rules={[{ required: true, message: "Please select case3!" }]}
          >
            <Select onChange={handleCase3Change} allowClear>
              {/* หน้าทำงาน: โชว์เฉพาะ case3 ที่เปิดใช้งาน (คงตัวที่เลือกอยู่ไว้) */}
              {case3Options
                .filter((item) => Number(item.enable) !== 0 || item.id === selectedCase3?.id)
                .map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.casename}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item name="transactionId" label="Transaction ID">
            <Input placeholder="Transaction ID" />
          </Form.Item>
          <Form.Item name="radioChoice" initialValue={"1"}>
            <Radio.Group onChange={handleRadioChange} value={radioValue}>
              <Radio value="1">เติม</Radio>
              <Radio value="2">ไม่เติม</Radio>
            </Radio.Group>
          </Form.Item>
          

          {/* Copyable text box when "เติม" is selected */}
          {radioValue === "1" && (
            <>
              <Form.Item name="remarkText" style={{ marginBottom: 16 }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <Input
                    value={remarkText}
                    readOnly
                    placeholder="เลือก Case ก่อน Copy"
                    style={{
                      width: "100%",
                      fontFamily: "monospace",
                      fontSize: "14px",
                    }}
                  />
                  <Button
                    type="primary"
                    size="small"
                    icon={<CopyOutlined />}
                    onClick={handleCopyText}
                  >
                    Copy
                  </Button>
                </div>
              </Form.Item>
              <div
                className="col-span-2"
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <Form.Item
                  name="amount"
                  label="Amount"
                  style={{ marginBottom: 16 }}
                  className="numeric-input"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the amount!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter amount"
                    style={{ width: "200px" }}
                    type="text"
                    inputMode="decimal"
                    pattern="^[0-9]*\.?[0-9]*$"
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                    }}
                  />
                </Form.Item>
                <Form.Item
                  name="timeDeposit"
                  onChange={(e) => {
                    setRemarkText(generateRemarkText());
                  }}
                  style={{ marginBottom: 16 }}
                  label="Time (สลิป)"
                  rules={[
                    {
                      pattern: /^([0-1]?[0-9]|2[0-3])\.[0-5][0-9]$/,
                      message: "กรุณากรอกเวลาในรูปแบบ 00.00 ",
                      required: selectedCase1 == 1 || selectedCase1 == 2 ? true : false,
                    },
                  ]}
                >
                  <Input placeholder="กรอกเวลา(00.00)" maxLength={5} />
                </Form.Item>
              </div>
              <Form.Item
                name="dateDeposit"
                style={{
                  marginBottom: 16,
                  color: "red" // สีแดง
                }}
                label={
                  <span>
                    เลือกวันที่
                    &nbsp;<span style={{ color: "red" }}>
                      (กรณีเติมย้อนหลัง)
                    </span>
                  </span>
                }
              >
                <DatePicker
                  placeholder="เลือกวันที่"
                  style={{ width: "100%" }}
                  format="DD/MM/YYYY"
                  onChange={(date) => {
                    setRemarkText(generateRemarkText());
                  }}
                />
              </Form.Item>
            </>
          )}

          {/* Reject Case Button */}
          {editingRecord && (
            <div style={{ marginTop: 16, textAlign: "left" }}>
              <Button
                type="primary"
                danger
                onClick={handleRejectCase}
                loading={isRejecting}
                style={{
                  marginRight: 8,
                  ...(editingRecord.status === "Reject" && {
                    backgroundColor: "#d9d9d9",
                    borderColor: "#d9d9d9",
                    color: "#bfbfbf",
                  }),
                }}
                disabled={editingRecord.status === "Reject"}
              >
                Reject Case
              </Button>
              <Button
                type="primary"
                onClick={handleInformCase}
                loading={isInforming}
                title="ส่งกลับเพื่อขอข้อมูลเพิ่ม (ไม่นับเป็นความผิด)"
                style={{
                  marginRight: 8,
                  backgroundColor:
                    editingRecord.status === "Inform" ? "#d9d9d9" : "#fa8c16",
                  borderColor:
                    editingRecord.status === "Inform" ? "#d9d9d9" : "#fa8c16",
                  ...(editingRecord.status === "Inform" && { color: "#bfbfbf" }),
                }}
                disabled={editingRecord.status === "Inform"}
              >
                Inform
              </Button>
              <Button
                type="primary"
                style={{
                  backgroundColor:
                    editingRecord.status === "Pending" ? "#d9d9d9" : "#faad14",
                  borderColor:
                    editingRecord.status === "Pending" ? "#d9d9d9" : "#faad14",
                  color:
                    editingRecord.status === "Pending" ? "#bfbfbf" : "#fff",
                }}
                onClick={handlePendingCase}
                loading={isPending}
                disabled={editingRecord.status === "Pending"}
              >
                Pending
              </Button>
              {slipProviders.length > 0 && (
                <Button
                  type="primary"
                  style={{
                    marginLeft: 8,
                    backgroundColor: "#1677ff",
                    borderColor: "#1677ff",
                  }}
                  onClick={handleOpenSlipModal}
                >
                  ส่งสลิป
                </Button>
              )}
              {chatTargets.length > 0 && (
                <Button
                  type="primary"
                  style={{
                    marginLeft: 8,
                    backgroundColor: "#0088cc",
                    borderColor: "#0088cc",
                  }}
                  onClick={handleOpenChatModal}
                >
                  ส่งแชท
                </Button>
              )}
              <Button
                danger
                style={{ marginLeft: 8 }}
                onClick={handleOpenBlacklistModal}
              >
                Blacklist
              </Button>
              <Button
                danger
                type="dashed"
                style={{ marginLeft: 8 }}
                onClick={handleOpenManualBlacklistModal}
              >
                Blacklist (กรอกเอง)
              </Button>
            </div>
          )}
        </Col>

        {/* Right side - Tabbed interface */}
        <Col span={16}>
          <Tabs activeKey={activeTab} onChange={setActiveTab}>
            <Tabs.TabPane key="1" tab="Receipt">
              <div style={{ padding: "16px" }}>
                {editingRecord &&
                  editingRecord.imgRecipe &&
                  editingRecord.imgRecipe.length > 0 ? (
                  <div>
                    <div
                      style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
                    >
                      {editingRecord.imgRecipe.map((image, index) => (
                        <div
                          key={index}
                          style={{
                            width: "250px",
                            position: "relative",
                            cursor: "pointer",
                          }}
                        >
                          <img
                            src={image.img_url}
                            alt={`Image ${index + 1}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "4px",
                              border: "1px solid #d9d9d9",
                              objectFit: "cover",
                            }}
                            onClick={() => showImageModal(image.img_url)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      color: "#999",
                      padding: "20px",
                    }}
                  >
                    ไม่มีรูปภาพจาก API
                  </div>
                )}
              </div>
            </Tabs.TabPane>
            {customFieldOptions.map((field) => (
              <Tabs.TabPane
                key={(field.number + 1).toString()}
                tab={`${field.number}. ${field.title}`}
              >
                <div style={{ padding: "16px" }}>
                  {/* Example Image and Description Collapse */}
                  {(field.example_image || field.description) && (
                    <Collapse
                      size="small"
                      style={{ marginBottom: "16px" }}
                      items={[
                        {
                          key: "1",
                          label: "📋 ตัวอย่าง",
                          children: (
                            <div>
                              {field.example_image && (
                                <div style={{ marginBottom: "12px" }}>
                                  <Image
                                    width={200}
                                    height={150}
                                    src={field.example_image}
                                    style={{
                                      objectFit: "cover",
                                      borderRadius: "6px",
                                    }}
                                    fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3Ik1RnG4W+FgYxN"
                                  />
                                </div>
                              )}
                              {field.description && (
                                <div>
                                  <div
                                    style={{
                                      fontWeight: "500",
                                      marginBottom: "8px",
                                      color: "#666",
                                    }}
                                  >
                                    คำอธิบาย:
                                  </div>
                                  <div
                                    style={{
                                      padding: "8px 12px",
                                      backgroundColor: "#f5f5f5",
                                      borderRadius: "6px",
                                      border: "1px solid #e8e8e8",
                                      color: "#333",
                                      fontSize: "14px",
                                      lineHeight: "1.6",
                                    }}
                                  >
                                    {field.description
                                      .split("\n")
                                      .map((line, index) => {
                                        // ตรวจสอบว่าเป็นรายการที่มีหมายเลขหรือไม่
                                        const numberedItem =
                                          line.match(/^(\d+)\.\s*(.+)$/);
                                        if (numberedItem) {
                                          return (
                                            <div
                                              key={index}
                                              style={{ marginBottom: "8px" }}
                                            >
                                              <span
                                                style={{
                                                  fontWeight: "500",
                                                  color: "#1890ff",
                                                }}
                                              >
                                                {numberedItem[1]}.
                                              </span>
                                              <span
                                                style={{ marginLeft: "4px" }}
                                              >
                                                {numberedItem[2]}
                                              </span>
                                            </div>
                                          );
                                        } else if (line.trim()) {
                                          // ถ้าไม่ใช่รายการที่มีหมายเลข แต่มีข้อความ
                                          return (
                                            <div
                                              key={index}
                                              style={{ marginBottom: "4px" }}
                                            >
                                              {line}
                                            </div>
                                          );
                                        }
                                        return null;
                                      })}
                                  </div>
                                </div>
                              )}
                            </div>
                          ),
                        },
                      ]}
                    />
                  )}

                  {/* เช็คโปรวันเกิด = เครื่องมือช่วยดู ไม่ผูก Form.Item จึงไม่มีค่าเก็บ
                      และไม่บังคับกรอก (ต่อให้ตั้ง required ไว้ก็ไม่บล็อกการส่งเคส) */}
                  {field.type === CUSTOMFIELD_TYPE.birthday_promo ? (
                    <BirthdayPromoCheck caseUserId={blacklistUserId} />
                  ) : (
                  <Form.Item
                    name={["customFields", field.number.toString()]}
                    dependencies={
                      field.typeDisplay === "Image" ? ["case1"] : []
                    }
                    rules={[
                      {
                        required: field.typeDisplay === "Image" ? false : true,
                        validator: (_, value) => {
                          if (field.typeDisplay === "Image") {
                            const case1Value = form.getFieldValue("case1");
                            if (
                              case1Value === "1" &&
                              (!imageSrc[field.number] ||
                                imageSrc[field.number].length === 0)
                            ) {
                              return Promise.reject(
                                new Error(
                                  `กรุณาอัพโหลดรูปภาพ ${field.number}. ${field.title} สำหรับ Deposit`
                                )
                              );
                            }
                          } else if (!value) {
                            return Promise.reject(
                              new Error(
                                `Please input ${field.number}. ${field.title}!`
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    {field.typeDisplay === "Text" && (
                      <Input required={field.required} />
                    )}
                    {field.typeDisplay === "Number" && (
                      <Input type="number" required={field.required} />
                    )}
                    {field.typeDisplay === "Date" && (
                      <DatePicker
                        style={{ width: "100%" }}
                        required={field.required}
                      />
                    )}
                    {field.typeDisplay === "Select" && (
                      <Select
                        placeholder={`Select ${field.number}. ${field.title}`}
                        required={field.required}
                      >
                        {field.options?.map((option) => (
                          <Select.Option
                            key={option.value}
                            value={option.value}
                          >
                            {option.label}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                    {field.typeDisplay === "Textarea" && (
                      <Input.TextArea rows={4} required={field.required} />
                    )}
                    {field.typeDisplay === "Image" && (
                      <div>
                        <textarea
                          ref={(el) =>
                            (textareaRefs.current[field.number] = el)
                          }
                          placeholder="กด Ctrl+V เพื่อวางรูป"
                          onPaste={(e) => handlePaste(e, field.number)}
                          rows={2}
                          style={{
                            width: "100%",
                            padding: "8px",
                            border: "1px solid #d9d9d9",
                            borderRadius: "6px",
                          }}
                        />
                        {imageSrc[field.number] &&
                          imageSrc[field.number].length > 0 && (
                            <>
                              <div className="mt-2 mb-1">
                                <strong>Preview รูป:</strong>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                {imageSrc[field.number].map((src, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      width: "100px",
                                      position: "relative",
                                    }}
                                  >
                                    <img
                                      src={src}
                                      alt="pasted"
                                      style={{
                                        maxWidth: "100%",
                                        height: "auto",
                                        borderRadius: "4px",
                                      }}
                                    />
                                    <Button
                                      type="text"
                                      icon={<CloseOutlined />}
                                      onClick={() =>
                                        handleDeleteImage(field.number, index)
                                      }
                                      style={{
                                        position: "absolute",
                                        top: "-8px",
                                        right: "-8px",
                                        background: "#ff4d4f",
                                        color: "white",
                                        borderRadius: "50%",
                                        width: "20px",
                                        height: "20px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "none",
                                        zIndex: 1,
                                        fontSize: "12px",
                                        padding: 0,
                                        minWidth: "20px",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            </>
                          )}
                      </div>
                    )}
                  </Form.Item>
                  )}
                </div>
              </Tabs.TabPane>
            ))}
          </Tabs>

          <div style={{ marginTop: 16, textAlign: "right" }}>
            {customFieldOptions.length > 1 && activeTab !== "1" && (
              <Button style={{ marginRight: 8 }} onClick={handlePrevTab}>
                Previous
              </Button>
            )}
            {customFieldOptions.length > 1 &&
              (() => {
                const currentIndex = customFieldOptions.findIndex(
                  (field) => (field.number + 1).toString() === activeTab
                );
                return (
                  currentIndex >= 0 &&
                  currentIndex < customFieldOptions.length - 1
                );
              })() && (
                <Button
                  type="primary"
                  onClick={handleNextTab}
                  style={{ marginRight: 8 }}
                >
                  Next
                </Button>
              )}
          </div>
        </Col>
      </Row>

      {/* Reject Case Modal */}
      <Modal
        title="Reject Case"
        open={isRejectModalOpen}
        onOk={handleRejectSubmit}
        onCancel={handleRejectCancel}
        okText="Reject"
        cancelText="Cancel"
        okButtonProps={{ danger: true, loading: isRejecting }}
        width={600}
      >
        <Form form={rejectForm} layout="vertical">
          <Form.Item
            name="rejectRemark"
            label="เหตุผลในการ Reject"
            rules={[
              { required: true, message: "กรุณากรอกเหตุผลในการ reject!" },
            ]}
          >
            <Input.TextArea
              rows={4}
              placeholder="กรุณาระบุเหตุผลในการ reject case นี้..."
            />
          </Form.Item>

          <Form.Item label="รูปภาพประกอบ (ถ้ามี)">
            <div>
              <textarea
                placeholder="กด Ctrl+V เพื่อวางรูป"
                onPaste={handleRejectImagePaste}
                rows={2}
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #d9d9d9",
                  borderRadius: "6px",
                }}
              />
              {rejectImages.length > 0 && (
                <>
                  <div className="mt-2 mb-1">
                    <strong>Preview รูป:</strong>
                  </div>
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
                  >
                    {rejectImages.map((src, index) => (
                      <div
                        key={index}
                        style={{ width: "100px", position: "relative" }}
                      >
                        <img
                          src={src}
                          alt="pasted"
                          style={{
                            maxWidth: "100%",
                            height: "auto",
                            borderRadius: "4px",
                          }}
                        />
                        <Button
                          type="text"
                          icon={<CloseOutlined />}
                          onClick={() => handleDeleteRejectImage(index)}
                          style={{
                            position: "absolute",
                            top: "-8px",
                            right: "-8px",
                            background: "#ff4d4f",
                            color: "white",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "none",
                            zIndex: 1,
                            fontSize: "12px",
                            padding: 0,
                            minWidth: "20px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </Form.Item>
        </Form>
      </Modal>

      {/* Inform Case Modal — ขอข้อมูลเพิ่ม ไม่ใช่การตัดสินว่าผิด */}
      <Modal
        title="ขอข้อมูลเพิ่มเติม (Inform)"
        open={isInformModalOpen}
        onOk={handleInformSubmit}
        onCancel={handleInformCancel}
        okText="ส่งกลับขอข้อมูล"
        cancelText="ยกเลิก"
        okButtonProps={{
          loading: isInforming,
          style: { backgroundColor: "#fa8c16", borderColor: "#fa8c16" },
        }}
        width={600}
      >
        <div style={{ marginBottom: 12, color: "#8c8c8c" }}>
          ใช้เมื่อเคสถูกต้องแต่ข้อมูลไม่พอทำต่อ — เคสจะกลับไปหาคนส่งเพื่อเติมข้อมูล
          และ<strong>ไม่ถูกนับเป็นความผิด</strong>
        </div>
        <Form form={informForm} layout="vertical">
          <Form.Item
            name="informRemark"
            label="ต้องการข้อมูลอะไรเพิ่ม"
            rules={[
              { required: true, message: "กรุณาระบุข้อมูลที่ต้องการเพิ่ม!" },
            ]}
          >
            <Input.TextArea
              rows={4}
              placeholder="เช่น รบกวนแนบสลิปที่ชัดกว่านี้ / ขอเวลาทำรายการด้วยค่ะ"
            />
          </Form.Item>

          <Form.Item label="รูปภาพประกอบ (ถ้ามี)">
            <div>
              <textarea
                placeholder="กด Ctrl+V เพื่อวางรูป"
                onPaste={handleInformImagePaste}
                rows={2}
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #d9d9d9",
                  borderRadius: "6px",
                }}
              />
              {informImages.length > 0 && (
                <>
                  <div className="mt-2 mb-1">
                    <strong>Preview รูป:</strong>
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                    {informImages.map((src, index) => (
                      <div
                        key={index}
                        style={{ width: "100px", position: "relative" }}
                      >
                        <img
                          src={src}
                          alt="pasted"
                          style={{
                            maxWidth: "100%",
                            height: "auto",
                            borderRadius: "4px",
                          }}
                        />
                        <Button
                          type="text"
                          icon={<CloseOutlined />}
                          onClick={() => handleDeleteInformImage(index)}
                          style={{
                            position: "absolute",
                            top: "-8px",
                            right: "-8px",
                            background: "#ff4d4f",
                            color: "white",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "none",
                            zIndex: 1,
                            fontSize: "12px",
                            padding: 0,
                            minWidth: "20px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </Form.Item>
        </Form>
      </Modal>

      {/* Pending Case Modal */}
      <Modal
        title="ยืนยันการเปลี่ยนสถานะ"
        open={isPendingModalOpen}
        onOk={handlePendingSubmit}
        onCancel={handlePendingCancel}
        okText="ยืนยัน"
        cancelText="ยกเลิก"
        okButtonProps={{ loading: isPending }}
      >
        <Form form={pendingForm} layout="vertical">
          <Form.Item
            name="pendingRemark"
            label="เหตุผลในการ Pending"
            rules={[
              { required: true, message: "กรุณากรอกเหตุผลในการ Pending!" },
            ]}
          >
            <Input.TextArea
              rows={4}
              placeholder="กรุณาระบุเหตุผลในการ Pending case นี้..."
            />
          </Form.Item>
        </Form>
      </Modal>

      {/* Slip Deposit Modal */}
      <Modal
        title="ส่งสลิป (Deposit)"
        open={isSlipModalOpen}
        onCancel={handleSlipModalCancel}
        okText="ส่งสลิป"
        cancelText="ยกเลิก"
        onOk={handleSendSlip}
        okButtonProps={{
          loading: isSendingSlip,
          disabled: !slipQrString || !selectedProviderId || !slipTransactionId,
        }}
        width={640}
      >
        {/* เลือกผู้ให้บริการ (ถ้ามีหลายเจ้า) */}
        <div style={{ marginBottom: 16 }}>
          <div style={{ marginBottom: 4, fontWeight: 500 }}>ผู้ให้บริการ</div>
          <Select
            style={{ width: "100%" }}
            placeholder="เลือกผู้ให้บริการ"
            value={selectedProviderId}
            onChange={setSelectedProviderId}
          >
            {slipProviders.map((p) => (
              <Select.Option key={p.id} value={p.id}>
                {p.name}
              </Select.Option>
            ))}
          </Select>
        </div>

        {/* Transaction ID (prefill จากฟอร์ม / ts_id แก้ได้) */}
        <div style={{ marginBottom: 16 }}>
          <div style={{ marginBottom: 4, fontWeight: 500 }}>Transaction ID</div>
          <Input
            value={slipTransactionId}
            onChange={(e) => setSlipTransactionId(e.target.value)}
            placeholder="กรอก Transaction ID"
          />
        </div>

        {/* เลือกรูปสลิปเพื่อถอด QR */}
        <div style={{ marginBottom: 8, fontWeight: 500 }}>
          เลือกรูปสลิป (กดที่รูปเพื่อถอด QR)
        </div>
        {editingRecord?.imgRecipe?.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 16 }}>
            {editingRecord.imgRecipe.map((image, index) => (
              <img
                key={index}
                src={image.img_url}
                alt={`slip ${index + 1}`}
                onClick={() => handleSelectSlipImage(image.img_url)}
                style={{
                  width: 90,
                  height: 90,
                  objectFit: "cover",
                  borderRadius: 6,
                  cursor: "pointer",
                  border:
                    selectedSlipImage === image.img_url
                      ? "3px solid #1677ff"
                      : "1px solid #d9d9d9",
                }}
              />
            ))}
          </div>
        ) : (
          <div style={{ color: "#999", marginBottom: 16 }}>
            ไม่มีรูปสลิปในเคสนี้ กรุณากรอก QR เอง
          </div>
        )}

        {/* QR string (แก้ไข/กรอกเองได้ ถ้าถอดไม่ออก) */}
        <div style={{ marginBottom: 4, fontWeight: 500 }}>
          QR String {isDecodingQr && <span style={{ color: "#1677ff" }}>(กำลังถอด...)</span>}
        </div>
        <Input.TextArea
          rows={3}
          value={slipQrString}
          onChange={(e) => setSlipQrString(e.target.value)}
          placeholder="เลือกรูปเพื่อถอด QR อัตโนมัติ หรือกรอก QR string เอง"
        />
      </Modal>

      {/* ส่งแชท Telegram Modal (รูปสลิป + ข้อความเข้ากลุ่ม) */}
      <Modal
        title="ส่งแชท (เข้ากลุ่ม Telegram)"
        open={isChatModalOpen}
        onCancel={() => setIsChatModalOpen(false)}
        okText="ส่งเข้ากลุ่ม"
        cancelText="ยกเลิก"
        onOk={handleSendChat}
        okButtonProps={{
          loading: isSendingChat,
          disabled: !selectedChatTargetId || !chatImageUrl,
          style: { backgroundColor: "#0088cc", borderColor: "#0088cc" },
        }}
        width={640}
      >
        {/* เลือกเจ้า/กลุ่ม */}
        <div style={{ marginBottom: 16 }}>
          <div style={{ marginBottom: 4, fontWeight: 500 }}>Payment (เจ้า/กลุ่ม)</div>
          <Select
            style={{ width: "100%" }}
            placeholder="เลือกเจ้า/กลุ่มปลายทาง"
            value={selectedChatTargetId}
            onChange={setSelectedChatTargetId}
          >
            {chatTargets.map((t) => (
              <Select.Option key={t.id} value={t.id}>
                {t.name}
              </Select.Option>
            ))}
          </Select>
        </div>

        {/* เลือกรูปสลิป */}
        <div style={{ marginBottom: 8, fontWeight: 500 }}>เลือกรูปสลิป</div>
        {editingRecord?.imgRecipe?.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 16 }}>
            {editingRecord.imgRecipe.map((image, index) => (
              <img
                key={index}
                src={image.img_url}
                alt={`slip ${index + 1}`}
                onClick={() => setChatImageUrl(image.img_url)}
                style={{
                  width: 90,
                  height: 90,
                  objectFit: "cover",
                  borderRadius: 6,
                  cursor: "pointer",
                  border:
                    chatImageUrl === image.img_url
                      ? "3px solid #0088cc"
                      : "1px solid #d9d9d9",
                }}
              />
            ))}
          </div>
        ) : (
          <div style={{ color: "#999", marginBottom: 16 }}>ไม่มีรูปสลิปในเคสนี้</div>
        )}

        {/* ข้อความ (prefill เลขธุรกรรม — แก้/พิมพ์เองได้) */}
        <div style={{ marginBottom: 4, fontWeight: 500 }}>Transaction ID</div>
        <Input.TextArea
          rows={3}
          value={chatCaption}
          onChange={(e) => setChatCaption(e.target.value)}
          placeholder="ข้อความที่จะส่งไปกับรูป (ปกติคือเลขธุรกรรม)"
        />
      </Modal>

      {/* Blacklist Modal (เพิ่มรายการ) */}
      <Modal
        title={blacklistMode === "manual" ? "เพิ่ม Blacklist (กรอกเอง)" : "เพิ่ม Blacklist"}
        open={isBlacklistModalOpen}
        onOk={handleSubmitBlacklist}
        onCancel={() => setIsBlacklistModalOpen(false)}
        okText="บันทึก"
        cancelText="ยกเลิก"
        okButtonProps={{ loading: isSavingBlacklist, danger: true }}
        width={520}
      >
        <Form form={blacklistForm} layout="vertical">
          {blacklistMode === "manual" ? (
            <Form.Item
              name="manualUserId"
              label="UserId (ลูกค้า)"
              extra="ไม่ผูกกับเคสที่เปิดอยู่ — ใช้เพิ่ม blacklist ของ user คนอื่นได้"
              rules={[{ required: true, whitespace: true, message: "กรุณากรอก UserId" }]}
            >
              <Input placeholder="กรอก UserId / เบอร์โทรลูกค้า" maxLength={50} />
            </Form.Item>
          ) : null}
          {blacklistMode === "manual" && manualCheckId ? (
            <div style={{ marginTop: -12, marginBottom: 16, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              {isCheckingManual ? (
                <span style={{ color: "#999" }}>กำลังเช็ค Blacklist ของ {manualCheckId}…</span>
              ) : isManualCheckError ? (
                <span style={{ color: "#faad14" }}>เช็ค Blacklist ไม่สำเร็จ ลองพิมพ์ใหม่อีกครั้ง</span>
              ) : manualBlacklist.length > 0 ? (
                <>
                  <span style={{ color: "#ff4d4f", fontWeight: "bold" }}>
                    ⚠ {manualCheckId} มี Blacklist อยู่แล้ว {manualBlacklist.length} รายการ
                  </span>
                  <Button
                    size="small"
                    onClick={() => {
                      setBlacklistViewTarget("manual");
                      setIsBlacklistViewOpen(true);
                    }}
                  >
                    ดูรายละเอียด
                  </Button>
                </>
              ) : (
                <span style={{ color: "#52c41a" }}>✓ {manualCheckId} ยังไม่มี Blacklist</span>
              )}
            </div>
          ) : null}
          {blacklistMode === "manual" ? null : (
            <Form.Item label="UserId (ลูกค้า)">
              <Input value={blacklistUserId || ""} disabled />
            </Form.Item>
          )}
          <Form.Item
            name="topicId"
            label="หัวข้อ"
            rules={[{ required: true, message: "กรุณาเลือกหัวข้อ" }]}
          >
            <Select placeholder="เลือกหัวข้อ blacklist">
              {blacklistTopics.map((t) => (
                <Select.Option key={t.id} value={t.id}>
                  {t.topic}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="accountName"
            label="ชื่อบัญชี (ชื่อ-สกุล)"
            rules={[{ required: true, message: "กรุณากรอกชื่อบัญชี" }]}
          >
            <Input placeholder="เช่น สมชาย ใจดี" />
          </Form.Item>
          <Form.Item name="bank" label="ธนาคาร">
            <Select placeholder="เลือกธนาคาร" showSearch optionFilterProp="children" allowClear>
              {bankList.map((b) => (
                <Select.Option key={b.code} value={b.thai_name}>
                  {b.thai_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="bankAccount" label="เลขบัญชี">
            <Input placeholder="กรอกเลขบัญชี" />
          </Form.Item>
          <Form.Item name="note" label="หมายเหตุ">
            <Input.TextArea rows={3} placeholder="รายละเอียดเพิ่มเติม (ถ้ามี)" maxLength={500} showCount />
          </Form.Item>
        </Form>
      </Modal>

      {/* Blacklist View Modal (ดูว่า user ติดหัวข้อไหนบ้าง) */}
      <Modal
        title={`Blacklist ของ ${viewBlacklistUserId || ""} (${viewBlacklist.length} รายการ)`}
        open={isBlacklistViewOpen}
        onCancel={() => setIsBlacklistViewOpen(false)}
        footer={null}
        width={560}
        // ต้องอยู่บนสุดเสมอ — เปิดจากในป๊อปอัป "เพิ่ม Blacklist (กรอกเอง)" ได้
        // antd ไม่ลบกล่องของ modal ที่เคยเปิดแล้วออกจากหน้า ถ้าเคยเปิดหน้านี้ก่อน (ปุ่มดูของเคส)
        // แล้วค่อยเปิดป๊อปอัปเพิ่ม → z-index เท่ากัน ตัวที่อยู่ก่อนใน DOM จะจมอยู่ข้างหลัง
        zIndex={1500}
      >
        {viewBlacklist.length === 0 ? (
          <div style={{ color: "#999" }}>ไม่มีรายการ</div>
        ) : (
          viewBlacklist.map((b) => (
            <div
              key={b.id}
              style={{
                border: "1px solid #f0f0f0",
                borderRadius: 6,
                padding: "8px 12px",
                marginBottom: 8,
              }}
            >
              <div style={{ fontWeight: "bold", color: "#ff4d4f" }}>
                {b.topic_name || "-"}
              </div>
              <div>ชื่อบัญชี: {b.account_name || "-"}</div>
              <div>ธนาคาร: {b.bank || "-"} / เลขบัญชี: {b.bank_account || "-"}</div>
              {b.note && <div>หมายเหตุ: {b.note}</div>}
              <div style={{ color: "#999", fontSize: 12 }}>
                {b.create_date ? dayjs(b.create_date).format("DD/MM/YYYY HH:mm") : ""}
              </div>
            </div>
          ))
        )}
      </Modal>
    </Form>
  );
}

export default CaseForm;
